import forEach from '../../../../javascripts/dom/forEach';

const formInputs = document.querySelectorAll('[data-js-module="a-form-input"]');

const init = async () => {
  const { default: FormInput } = await import(
    /* webpackChunkName: "a-form-input" */ './form-input.js'
  );

  forEach(formInputs, (index, element) => new FormInput(element));
};

if (formInputs.length) init();
